<template>
	<ProjectSelect v-bind="$attrs" v-on="$listeners" :projects="localProjects" />
</template>

<script>
import ProjectSelect from './ProjectSelect.vue';
import ProjectsService from '@/utils/projects-service';
import { mapGettersShorthand } from '@/store/utils/mappers';
import { projectsList } from '@/store/modules/projects/getters';
import { projectHasPermission } from '@/store/modules/projects/getters';

export default {
	name: 'ProjectSelectDataProvider',
	props: {
		filterOutIds: { type: Array, default: null },
		filterInIds: { type: Array, default: null },
		permission: { type: String },
	},
	components: { ProjectSelect },
	computed: {
		...mapGettersShorthand({ projectsList, projectHasPermission }),
		projects() {
			return ProjectsService.getFilteredProjectsList(this.projectsList, this.filterOutIds, this.filterInIds);
		},
		localProjects() {
			return this.projects.map((project) => ({ ...project, disabled: !this.canChoose(project.id) }));
		},
	},
	methods: {
		canChoose(projectId) {
			if (this.permission) {
				return this.projectHasPermission(projectId, this.permission);
			}
			return true;
		},
	},
};
</script>

<style lang="scss" scoped></style>
